<template>
    <div class="fileUpload-as-button">
        <div class="fileUpload" :class="{ disabled: iniDisabled }">
            <span v-if="hasFiles && !hidePreview">
                <ul class="list-group">
                    <li class="list-group-item preview" v-for="(file, index) in files" :key="index">
                        <div class="image">
                            <img :src="file.src" />
                        </div>
                        <!--
                    <span class="name">
                        <font-awesome-icon :icon="['fas', 'image']" v-if="file.type && file.type.indexOf('image')>-1"/>
                        <font-awesome-icon :icon="['fas', 'file-pdf']" v-if="file.type && file.type.indexOf('pdf')>-1"/>
                        {{file.name}}
                        <small>({{Number(file.size/1000).toFixed(2)}}KB)</small>
                    </span>
                    -->
                        <div class="actions">
                            <b-button class="is-small is-danger" icon-left="trash-alt" @click="removeFile(index)">{{
                                $t('forms.remove')
                            }}</b-button>
                        </div>
                    </li>
                    <li class="list-group-item preview isNew" v-for="(file, index) in newFiles" :key="1000 + index">
                        <div class="image">
                            <img :src="file.src" />
                        </div>
                        <div class="actions">
                            <b-button class="is-small is-danger" icon-left="trash-alt" @click="removeNewFile(index)">{{
                                $t('forms.remove')
                            }}</b-button>
                        </div>
                    </li>
                </ul>
            </span>
            <span v-if="hasFiles && hidePreview">
                <ul class="list-group">
                    <li class="list-group-item" v-for="(file, index) in files" :key="index">
                        <b-button class="is-small is-danger" icon-left="trash-alt" @click="removeFile(index)">{{
                            $t('forms.remove')
                        }}</b-button>
                    </li>
                    <li class="list-group-item" v-for="(file, index) in newFiles" :key="1000 + index">
                        <b-button class="is-small is-danger" icon-left="trash-alt" @click="removeNewFile(index)">{{
                            $t('forms.remove')
                        }}</b-button>
                    </li>
                </ul>
            </span>
            <form enctype="multipart/form-data" novalidate v-if="showAdd">
                <div class="dropbox">
                    <input
                        type="file"
                        :disabled="iniDisabled"
                        :multiple="iniMultiple"
                        @change="handleFileChange"
                        :accept="allowedtypes"
                        class="input-file" />
                    <p>
                        {{ buttonText }}
                    </p>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faImage, faFilePdf } from '@fortawesome/free-solid-svg-icons';

library.add(faImage);
library.add(faFilePdf);

export default {
    name: 'fileUpload',
    components: {
        FontAwesomeIcon,
    },
    data() {
        return {
            files: null,
            newFiles: [],
        };
    },
    props: {
        allowedtypes: {
            default: '*',
            type: String,
        },
        iniFiles: {
            default: () => [],
            type: Array,
        },
        iniDisabled: {
            default: false,
            type: Boolean,
        },
        iniMultiple: {
            default: false,
            type: Boolean,
        },
        buttonText: {
            type: String,
        },
        hidePreview: {
            default: false,
            type: Boolean,
        },
    },
    watch: {
        iniFiles() {
            if (this.iniFiles) {
                this.files = this.iniFiles;
                //remove non-uploaded files
                this.newFiles = [];
            }
        },
    },
    computed: {
        showAdd() {
            if (this.hasFiles) {
                if (this.iniMultiple) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        },
        hasFiles() {
            if (this.files && this.files.length > 0) {
                return true;
            }
            if (this.newFiles && this.newFiles.length > 0) {
                return true;
            }
            return false;
        },
    },
    methods: {
        emitFilesSelected() {
            this.$emit('onFilesSelected', {
                newFiles: this.newFiles,
                files: this.files,
            });
        },
        async handleFileChange(e) {
            var newFiles = [...e.target.files];

            const promises = [];
            newFiles.forEach((file) => {
                var promise = new Promise((resolve, reject) => {
                    const fReader = new FileReader();
                    const img = new Image();

                    fReader.onload = () => {
                        img.src = fReader.result;
                        var newFile = {
                            file: file,
                            name: file.name,
                            src: img.src,
                            type: file.type,
                            size: file.size,
                            processed: true,
                        };
                        resolve(newFile);
                    };
                    fReader.readAsDataURL(file);
                });
                promises.push(promise);
            });

            await Promise.all(promises).then((values) => {
                this.newFiles = values;
            });

            //emit
            this.emitFilesSelected();
        },
        removeFile(index) {
            this.files.splice(index, 1);
            this.emitFilesSelected();
        },
        removeNewFile(index) {
            this.newFiles.splice(index, 1);
            this.emitFilesSelected();
        },
    },
    created() {
        if (this.iniFiles) {
            this.files = this.iniFiles;
        }
    },
};
</script>
